import '../App.scss'
import './DevicesPage.scss';


const Devices = () => {
    const hubList = [{
        name:"HUB 01",
        deviceID:"HB123545785",
        status:"Connected"
    },
    {
        name:"HUB 02",
        deviceID:"HB123545785",
        status:"Connected"
    }
]

const sensorList = [{
    name:"SENSOR 01",
    deviceID:"SN123545785",
    status:"Connected"
},
{
    name:"SENSOR 02",
    deviceID:"SN123545785",
    status:"Connected"
},
{
    name:"SENSOR 03",
    deviceID:"SN123545785",
    status:"Connected"
}
]
return(
<div className="pageContainer">
    <div className=" h1 row space-between centerAlign pageHeader">
        <div>Devices</div>
        <div><button className='button1 h3'>+ Add new Device</button></div>
    </div>
    <div style={{padding:" 1.5rem 2.2rem"}}>
        <div className="h2" style={{paddingBottom:"1.5rem"}}>HUBS</div>
        <div className="row wrapRow">
        {hubList.map((hub) => {
                    return(<div className="deviceCard" key={hub.name}>
                    <div className="h2 textCenter" style={{color:"var(--hippieBlue", marginBottom: "1rem"}}>{hub.name}</div>
                    <div className="grid deviceGrid">
                        <div className="h3">Device ID</div>
                        <div className="h4">{hub.deviceID}</div>
                        <div className="h3">Status</div>
                        <div className="h4">{hub.status}</div>
                    </div>
                    <div className='textCenter'><button style={{width:"100%", margin:"6.8rem auto"}} className='button1 h3'>REFRESH</button></div>
                </div>)
                })}
        </div>
    </div>

    <div style={{padding:" 1.5rem 2.2rem"}}>
        <div className="h2" style={{paddingBottom:"1.5rem"}}>SENSORS</div>
        <div className="row wrapRow">
            {sensorList.map((sensor) => {
                return(
                    <div className="deviceCard" key={sensor.name}>
                    <div className="h2 textCenter" style={{color:"var(--hippieBlue", marginBottom: "1rem"}}>{sensor.name}</div>
                    <div className="grid deviceGrid">
                        <div className="h3">Location</div>
                        <div className="h4">
                            <select className="sensorLocation b2" name="sensor1Location" id="sensor1Location">
                                <option value="right foot">Right Foot</option>
                                <option value="left foot">Left foot</option>
                                <option value="waist">Waist</option>
                            </select>
                        </div>
                        <div className="h3">Device ID</div>
                        <div className="h4">{sensor.deviceID}</div>
                        <div className="h3">Status</div>
                        <div className="h4">{sensor.status}</div>
                    </div>
                    <div className='textCenter'><button style={{width:"100%", margin:"5.4rem auto"}} className='button1 h3'>REFRESH</button></div>
                </div>
                )
            })}
           
        </div>
    </div>
    <div className="b2 textCenter" style={{color:"var(--midGray"}}> If you don't see your devices listed here, please add them.</div>
    </div>)
}

export default Devices;
